import { variantBAssets } from "../../../landers/Utils/variantBAssets";
import { PartnerAssociationBlock } from "./PartnerAssociationBlock";

export function LanderV2MarketingNav() {
  return (
    <header className="pa-vb-top">
      <img src={variantBAssets.penseLogo} alt="Pense" />
      <PartnerAssociationBlock className="pa-vb-associated" />
    </header>
  );
}
